import React from 'react';
import { ASSETS_FOLDER } from '../../../../../../constants';
import { SCENE_TOP } from '../../../../../../content';
import './TopMine.css';

const TopMine = props => {
  const { posX } = props;

  // mine style swap
  const style0 = {
    visibility: posX <= SCENE_TOP.LIMIT_2.MAX ? 'visible' : 'hidden',
  };

  const style1 = {
    visibility: posX >= SCENE_TOP.LIMIT_2.MIN ? 'visible' : 'hidden',
    opacity: Math.max(
      Math.min(
        (posX - SCENE_TOP.LIMIT_2.MIN) /
          (SCENE_TOP.LIMIT_2.MAX - SCENE_TOP.LIMIT_2.MIN),
        1
      ),
      0
    ),
  };

  // turn on mine lights
  const lightsActive = posX > SCENE_TOP.LIMIT_2.MAX;

  return (
    <div>
      <img
        className="top-mine-layer"
        src={`${ASSETS_FOLDER}img/scene/top/mine-0.png`}
        style={style0}
        alt=""
      />
      <img
        className="top-mine-layer"
        src={`${ASSETS_FOLDER}img/scene/top/mine-1.png`}
        style={style1}
        alt=""
      />

      <img
        className={`top-mine-layer lights ${lightsActive ? 'active' : ''}`}
        src={`${ASSETS_FOLDER}img/scene/top/mine-lights.png`}
        alt=""
      />

      <img
        className={`top-mine-layer light-win type-0 ${
          lightsActive ? 'active' : ''
        }`}
        src={`${ASSETS_FOLDER}img/scene/top/light-win-0.png`}
        alt=""
      />
      <img
        className={`top-mine-layer light-win type-1 ${
          lightsActive ? 'active' : ''
        }`}
        src={`${ASSETS_FOLDER}img/scene/top/light-win-1.png`}
        alt=""
      />

      <img
        className={`top-mine-layer lights-red type-0 ${
          lightsActive ? 'active' : ''
        }`}
        src={`${ASSETS_FOLDER}img/scene/top/lights-red-0.png`}
        alt=""
      />
      <img
        className={`top-mine-layer lights-red type-1 ${
          lightsActive ? 'active' : ''
        }`}
        src={`${ASSETS_FOLDER}img/scene/top/lights-red-1.png`}
        alt=""
      />

      <img
        className={`top-mine-layer lights-star type-0 ${
          lightsActive ? 'active' : ''
        }`}
        src={`${ASSETS_FOLDER}img/scene/top/star-0.png`}
        alt=""
      />
      <img
        className={`top-mine-layer lights-star type-1 ${
          lightsActive ? 'active' : ''
        }`}
        src={`${ASSETS_FOLDER}img/scene/top/star-1.png`}
        alt=""
      />
    </div>
  );
};

export default TopMine;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneTop/TopMine/TopMine.js